// Clerk Configuration Helper
export const checkClerkConfig = () => {
  const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
  
  if (!publishableKey) {
    console.error('❌ REACT_APP_CLERK_PUBLISHABLE_KEY is not set in environment variables');
    return false;
  }
  
  if (publishableKey === 'your_clerk_publishable_key_here') {
    console.error('❌ REACT_APP_CLERK_PUBLISHABLE_KEY is still set to template value');
    return false;
  }
  
  console.log('✅ Clerk configuration looks good');
  return true;
};

export const getClerkPublishableKey = () => {
  return process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '';
};